export function modelPrice(m) {
  const p = m?.pricing;
  if (!p) return null;
  const inTok = Number(p.prompt);
  const outTok = Number(p.completion);
  if (!isFinite(inTok) && !isFinite(outTok)) return null;
  const parts = [];
  if (isFinite(inTok)) parts.push(`${fmtPerM(inTok)} in`);
  if (isFinite(outTok)) parts.push(`${fmtPerM(outTok)} out`);
  return parts.length ? `${parts.join(" · ")} /M tok` : null;
}

function fmtPerM(v) {
  const per = v * 1e6;
  if (per === 0) return "free";
  if (per < 0.01) return `$${per.toFixed(3)}`;
  return `$${per.toFixed(2)}`;
}

export function fmtUSD(v) {
  if (v == null) return null;
  if (v === 0) return "free";
  if (v < 0.01) return `$${v.toFixed(4)}`;
  if (v < 1) return `$${v.toFixed(3)}`;
  return `$${v.toFixed(2)}`;
}

export function contextLabel(m) {
  const cl = m?.context_length;
  if (!cl) return null;
  return cl >= 1000 ? `${Math.round(cl / 1000)}K ctx` : `${cl} ctx`;
}

const RECOMMENDED = [
  "gemini-2.5", "gemini-3", "gemini-flash-latest",
  "claude-3.5-sonnet", "claude-3.7", "claude-sonnet-4", "claude-sonnet",
  "gpt-4o", "gpt-4.1", "gpt-5", "o3", "llama-3.3-70b",
];
export function isRecommended(id) {
  const s = (id || "").toLowerCase();
  return RECOMMENDED.some((r) => s.includes(r));
}

// Rough per-book corrector cost estimate from manuscript length.
// ~4 chars/token. Each passage is compared (original + translation) as input;
// corrections are short output.
export function estimateCost(charCount, modelObj, numLangs) {
  const p = modelObj?.pricing;
  if (!p || !charCount || !numLangs) return null;
  const priceIn = Number(p.prompt) || 0;
  const priceOut = Number(p.completion) || 0;
  const inTokPerLang = (charCount * 2) / 4;
  const outTokPerLang = (charCount * 0.3) / 4;
  const perLang = inTokPerLang * priceIn + outTokPerLang * priceOut;
  return { perLang, total: perLang * numLangs, inTok: inTokPerLang, outTok: outTokPerLang };
}
